import Component from '@glimmer/component'
import { action } from '@ember/object'
import { queryParam } from 'teacher-ui-client/decorators/query-param'
import { Sortable } from 'teacher-ui-client/components/th/sortable'
import { formatDate, t } from 'ember-intl'
import type { AssessmentsEventsReportData } from 'teacher-ui-client/reporting/ui-scope/rex/dashboard/student/index/route'
import { concat } from '@ember/helper'
import { colspanMax } from 'teacher-ui-client/modifiers/colspan-max'
import { formatValue } from 'teacher-ui-client/utils/format-value'

interface Args {
  isLoading: boolean
  eventsData: AssessmentsEventsReportData['events']
}

interface Signature {
  Args: Args
  Element: HTMLTableElement
}

export class StudentAssessmentsEventsDetailed extends Component<Signature> {
  @queryParam('reporting/ui-scope/rex/dashboard/student/assessments/index') sort!: string

  @action
  updateSort(newSort: string) {
    this.sort = newSort
  }

  <template>
    <table class="divide-oceany-blue-150 border-oceany-blue-150 divide-y border-b" ...attributes>
      <thead>
        <tr class="bg-oceany-blue-50 divide-x divide-white">
          <Sortable class="w-40" @sort={{this.sort}} @sortKey="created_at" @updateSort={{this.updateSort}}>
            {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.date"}}
          </Sortable>
          <Sortable @sort={{this.sort}} @sortKey="classification" @updateSort={{this.updateSort}}>
            {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.classification"}}
          </Sortable>
          <Sortable @sort={{this.sort}} @sortKey="lexile" @updateSort={{this.updateSort}}>
            {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.lexile"}}
          </Sortable>
          <Sortable @sort={{this.sort}} @sortKey="score" @updateSort={{this.updateSort}}>
            {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.score"}}
          </Sortable>
        </tr>
      </thead>
      <tbody class="divide-oceany-blue-150 divide-y {{if @isLoading 'opacity-50'}}">
        {{#each @eventsData as |event|}}
          <tr>
            <td class="p-3">{{formatDate event.created_at day="2-digit" month="short" year="numeric"}}</td>
            <td class="p-3">{{t (concat "classifications." event.classification)}}</td>

            <td class="p-3">{{formatValue event.lexile append="L"}}</td>
            <td class="p-3">{{formatValue event.score append="%"}}</td>
          </tr>
        {{else}}
          <tr>
            <td data-test-empty-message class="p-3 text-center italic" {{colspanMax}}>
              {{t "components.reporting.tables.readingEggspress.dashboardStudent.eventsEmptyMessage"}}
            </td>
          </tr>
        {{/each}}
      </tbody>
    </table>
  </template>
}

export default StudentAssessmentsEventsDetailed
